export enum AppType {
    ANDROID = 'ANDROID',
    IOS = 'IOS',
    WEB = 'WEB',
}
